import React, { Component } from 'react'
import Slider from 'react-slick'
import WrappedCorouselStyle from './corousel.style'
import SmallBanner1 from '../img/device/300x209 Simpel 1.svg'
import SmallBanner2 from '../img/device/300x209 Simpel 2.svg'
import SmallBanner3 from '../img/device/300x209 Komplit 1.svg'
import SmallBanner4 from '../img/device/300x209 Komplit 2.svg'
import LargeBanner1 from '../img/large/Simpel Komplit Web Banner-01.jpg'
import LargeBanner2 from '../img/large/Simpel Komplit Web Banner-02.jpg'
import LargeBanner3 from '../img/large/Simpel Komplit Web Banner-03.jpg'
import LargeBanner4 from '../img/large/Simpel Komplit Web Banner-04.jpg'

export default class Corousel extends Component {
  constructor (props) {
    super(props)
    this.state = {
      hideNav: ''
    }
    this.next = this.next.bind(this)
    this.previous = this.previous.bind(this)
  }
  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }
  resize() {
    this.setState({hideNav: window.innerWidth <= 760});
  }
  next () {
    this.slider.slickNext()
  }
  previous () {
    this.slider.slickPrev()
  }
  render () {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      autoplay: true
    }
    return (
      <WrappedCorouselStyle>
        <Slider ref={c => { this.slider = c }}{...settings}>
          <div className='corousel-content'>
            {
              (window.innerWidth <= 480) ? (
                <img alt='banner' src={SmallBanner1} style={{maxWidth: '100%', height: 'auto'}}/>
              ) : <img alt='banner' src={LargeBanner1} style={{maxWidth: '100%', height: 'auto'}}/>
            }
          </div>
          <div className='corousel-content'>
            {
              (window.innerWidth <= 480) ? (
                <img alt='banner' src={SmallBanner2} style={{maxWidth: '100%', height: 'auto'}}/>
              ) : <img alt='banner' src={LargeBanner2} style={{maxWidth: '100%', height: 'auto'}}/>
            }
          </div>
          <div className='corousel-content'>
            {
              (window.innerWidth <= 480) ? (
                <img alt='banner' src={SmallBanner3} style={{maxWidth: '100%', height: 'auto'}}/>
              ) : <img alt='banner' src={LargeBanner3} style={{maxWidth: '100%', height: 'auto'}}/>
            }
          </div>
          <div className='corousel-content'>
            {
              (window.innerWidth <= 480) ? (
                <img alt='banner' src={SmallBanner4} style={{maxWidth: '100%', height: 'auto'}}/>
              ) : <img alt='banner' src={LargeBanner4} style={{maxWidth: '100%', height: 'auto'}}/>
            }
          </div>
        </Slider>
      </WrappedCorouselStyle>
    )
  }
}



// WEBPACK FOOTER //
// ./src/component/common/corousel.js